import axios from "axios";
import { cmsEnv, headers } from "../exports/exports";
import { dynamicFailed } from "../hooks/custom/useToast";

export const fetchNews = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/news?sort=sort_order:asc`,
      {
        headers: {
          ...headers,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    dynamicFailed(error.response.data.error.message);
  }
};

export const fetchEvents = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/events?sort=sort_order:asc`,
      {
        headers: {
          ...headers,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    dynamicFailed(error.response.data.error.message);
  }
};
